import { Footer } from "../components/Footer";
import Header from "../components/Header";
import { TwoStepAuthenticationComponent } from "../components/pages/twoStepAuthentication";

export const TwoStepAuthentication = () => {
  window.scrollTo(0, 0);
  // Accessing the state using useSelector
   //   console.log(loginState);
   // State to manage the enabled/disabled status of Google Authenticator
  return (
    <>
      <Header />
      <TwoStepAuthenticationComponent />
      <Footer />
    </>
  );
};
